module.exports = __webpack_public_path__ + "img/swisscom-natelpay-alternate.e1135a96.png";